/* ISO 3166-1 alpha-2 country list with the African Union member
   states promoted to the top so annotators on this platform — which
   primarily serves African-language data collection — see the most
   relevant choices first. Followed by the rest of the world A→Z so
   diaspora annotators / partner researchers find their country
   without scrolling through 50 unfamiliar entries.
   The list is comprehensive (all UN-recognised countries + a few
   commonly-needed dependencies) so we don't have to ship updates
   when an annotator is in a country we hadn't anticipated. */

export const AFRICAN_COUNTRIES: [string, string][] = [
  ["NG", "Nigeria"],
  ["ZA", "South Africa"],
  ["KE", "Kenya"],
  ["GH", "Ghana"],
  ["ET", "Ethiopia"],
  ["EG", "Egypt"],
  ["TZ", "Tanzania"],
  ["UG", "Uganda"],
  ["RW", "Rwanda"],
  ["DZ", "Algeria"],
  ["MA", "Morocco"],
  ["TN", "Tunisia"],
  ["SN", "Senegal"],
  ["CI", "Côte d'Ivoire"],
  ["CM", "Cameroon"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"],
  ["BW", "Botswana"],
  ["NA", "Namibia"],
  ["MZ", "Mozambique"],
  ["AO", "Angola"],
  ["MG", "Madagascar"],
  ["MU", "Mauritius"],
  ["MW", "Malawi"],
  ["BJ", "Benin"],
  ["BF", "Burkina Faso"],
  ["BI", "Burundi"],
  ["CV", "Cabo Verde"],
  ["CF", "Central African Republic"],
  ["TD", "Chad"],
  ["KM", "Comoros"],
  ["CG", "Congo"],
  ["CD", "DR Congo"],
  ["DJ", "Djibouti"],
  ["GQ", "Equatorial Guinea"],
  ["ER", "Eritrea"],
  ["SZ", "Eswatini"],
  ["GA", "Gabon"],
  ["GM", "Gambia"],
  ["GN", "Guinea"],
  ["GW", "Guinea-Bissau"],
  ["LS", "Lesotho"],
  ["LR", "Liberia"],
  ["LY", "Libya"],
  ["ML", "Mali"],
  ["MR", "Mauritania"],
  ["NE", "Niger"],
  ["ST", "São Tomé and Príncipe"],
  ["SC", "Seychelles"],
  ["SL", "Sierra Leone"],
  ["SO", "Somalia"],
  ["SS", "South Sudan"],
  ["SD", "Sudan"],
  ["TG", "Togo"],
];

export const OTHER_COUNTRIES: [string, string][] = [
  ["US", "United States"],
  ["GB", "United Kingdom"],
  ["CA", "Canada"],
  ["AU", "Australia"],
  ["NZ", "New Zealand"],
  // EU / EEA
  ["DE", "Germany"],
  ["FR", "France"],
  ["IT", "Italy"],
  ["ES", "Spain"],
  ["NL", "Netherlands"],
  ["BE", "Belgium"],
  ["PT", "Portugal"],
  ["IE", "Ireland"],
  ["AT", "Austria"],
  ["DK", "Denmark"],
  ["SE", "Sweden"],
  ["FI", "Finland"],
  ["NO", "Norway"],
  ["IS", "Iceland"],
  ["CH", "Switzerland"],
  ["PL", "Poland"],
  ["CZ", "Czechia"],
  ["SK", "Slovakia"],
  ["HU", "Hungary"],
  ["RO", "Romania"],
  ["BG", "Bulgaria"],
  ["GR", "Greece"],
  ["HR", "Croatia"],
  ["SI", "Slovenia"],
  ["LT", "Lithuania"],
  ["LV", "Latvia"],
  ["EE", "Estonia"],
  ["LU", "Luxembourg"],
  ["MT", "Malta"],
  ["CY", "Cyprus"],
  // Americas
  ["BR", "Brazil"],
  ["MX", "Mexico"],
  ["AR", "Argentina"],
  ["CL", "Chile"],
  ["CO", "Colombia"],
  ["PE", "Peru"],
  ["VE", "Venezuela"],
  ["EC", "Ecuador"],
  ["UY", "Uruguay"],
  ["PY", "Paraguay"],
  ["BO", "Bolivia"],
  ["DO", "Dominican Republic"],
  ["GT", "Guatemala"],
  ["CU", "Cuba"],
  ["PA", "Panama"],
  ["CR", "Costa Rica"],
  ["JM", "Jamaica"],
  // Asia
  ["CN", "China"],
  ["IN", "India"],
  ["JP", "Japan"],
  ["KR", "South Korea"],
  ["ID", "Indonesia"],
  ["PH", "Philippines"],
  ["VN", "Vietnam"],
  ["TH", "Thailand"],
  ["MY", "Malaysia"],
  ["SG", "Singapore"],
  ["BD", "Bangladesh"],
  ["PK", "Pakistan"],
  ["LK", "Sri Lanka"],
  ["NP", "Nepal"],
  ["MM", "Myanmar"],
  ["KH", "Cambodia"],
  ["LA", "Laos"],
  ["MN", "Mongolia"],
  ["TW", "Taiwan"],
  ["HK", "Hong Kong"],
  // Middle East
  ["AE", "United Arab Emirates"],
  ["SA", "Saudi Arabia"],
  ["IL", "Israel"],
  ["TR", "Turkey"],
  ["IR", "Iran"],
  ["IQ", "Iraq"],
  ["JO", "Jordan"],
  ["LB", "Lebanon"],
  ["KW", "Kuwait"],
  ["QA", "Qatar"],
  ["OM", "Oman"],
  ["BH", "Bahrain"],
  ["YE", "Yemen"],
  ["PS", "Palestine"],
  // Eastern Europe / CIS
  ["RU", "Russia"],
  ["UA", "Ukraine"],
  ["BY", "Belarus"],
  ["MD", "Moldova"],
  ["GE", "Georgia"],
  ["AM", "Armenia"],
  ["AZ", "Azerbaijan"],
  ["KZ", "Kazakhstan"],
  ["UZ", "Uzbekistan"],
  ["KG", "Kyrgyzstan"],
  ["TJ", "Tajikistan"],
  ["TM", "Turkmenistan"],
  ["RS", "Serbia"],
  ["BA", "Bosnia and Herzegovina"],
  ["MK", "North Macedonia"],
  ["AL", "Albania"],
  ["ME", "Montenegro"],
  ["XK", "Kosovo"],
];
